<template>
	<div
		class="flex place-content-between border-b border-slate-100 p-4 hover:bg-sky-50"
	>
		<div class="flex select-text">
			<div class="min-w-8 p-1">
				<CheckCircleIcon
					class="h-5 w-5 text-indigo-300"
					v-if="isMatched"
				/>
			</div>
			<div>
				<div class="text-secondary-900">{{ location.name }}</div>
				<div class="text-sm text-[#0C58B7]">{{ location.id }}</div>
				<div class="text-secondary-900">
					{{ location.billingAddress?.street }} |
					{{ location.billingAddress?.city }},
					{{ location.billingAddress?.stateCode }}
				</div>
			</div>
		</div>
		<div class="flex flex-col justify-center">
			<ClipboardCopy :text-to-copy="location.id" />
		</div>
	</div>
</template>

<script setup lang="ts">
import ClipboardCopy from '../presentation/ClipboardCopy.vue'
import type { ApiV4FuneralHome } from '@/apiTypes'
import CheckCircleIcon from '@heroicons/vue/24/solid/CheckCircleIcon'
import { type PropType } from 'vue'

defineProps({
	location: {
		type: Object as PropType<ApiV4FuneralHome>,
		required: true,
	},
	isMatched: Boolean,
})
</script>
